require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./flexlayout"), require("./vspacer"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./flexlayout", "./vspacer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./flexlayout"), require("./vspacer")) : factory(root["./utils"], root["./flexlayout"], root["./vspacer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__44__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[42],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(376);


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Password = _interopRequireDefault(__webpack_require__(377));

exports.Password = _Password["default"];
exports["default"] = _Password["default"];

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _baUiCarbon = __webpack_require__(12);

var _vspacer = _interopRequireDefault(__webpack_require__(44));

var _flexlayout = _interopRequireDefault(__webpack_require__(16));

var _utils = __webpack_require__(4);

var _StringResource = _interopRequireDefault(__webpack_require__(378));

var _Password = _interopRequireDefault(__webpack_require__(380));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;

var pwdClassName = _Password["default"].pwdClassName.replace(/"/g, '');

var Password = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Password, _Component);

  function Password(props) {
    var _props$currentPasswor, _props$newPasswordPro, _props$confirmPasswor;

    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChangeCurrentPassword", function (event) {
      var onChange = _this.props.currentPasswordProps.onChange;

      _this.setState({
        currentPassword: event.currentTarget.value
      }, _this._onChange);

      onChange(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChangeNewPassword", function (event) {
      var onChange = _this.props.newPasswordProps.onChange;

      _this.setState({
        newPassword: event.currentTarget.value
      }, _this._onChange);

      onChange(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChangeConfirmPassword", function (event) {
      var onChange = _this.props.confirmPasswordProps.onChange;

      _this.setState({
        confirmPassword: event.currentTarget.value
      }, _this._onChange);

      onChange(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function () {
      return _this.props.onPwdChange({
        isValid: _this.state.isValid,
        currentPassword: _this.state.currentPassword,
        newPassword: _this.state.newPassword,
        confirmPassword: _this.state.confirmPassword,
        pwd: _this.state.newPassword,
        // remove when deprecated prop no longer used
        currentPwd: _this.state.currentPassword // remove when deprecated prop no longer used

      });
    });
    _this.state = {
      currentPassword: (_props$currentPasswor = props.currentPasswordProps.value) != null ? _props$currentPasswor : '',
      newPassword: (_props$newPasswordPro = props.newPasswordProps.value) != null ? _props$newPasswordPro : '',
      confirmPassword: (_props$confirmPasswor = props.confirmPasswordProps.value) != null ? _props$confirmPasswor : ''
    };
    return _this;
  }

  var _proto = Password.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var currentPasswordPropsPrev = prevProps.currentPasswordProps,
        newPasswordPropsPrev = prevProps.newPasswordProps,
        confirmPasswordPropsPrev = prevProps.confirmPasswordProps;
    var _this$props = this.props,
        currentPasswordPropsCurr = _this$props.currentPasswordProps,
        newPasswordPropsCurr = _this$props.newPasswordProps,
        confirmPasswordPropsCurr = _this$props.confirmPasswordProps;

    if (currentPasswordPropsPrev.value !== currentPasswordPropsCurr.value) {
      var _props$currentPasswor2;

      this.setState({
        currentPassword: (_props$currentPasswor2 = props.currentPasswordPropsCurr.value) != null ? _props$currentPasswor2 : ''
      });
    }

    if (newPasswordPropsPrev.value !== newPasswordPropsCurr.value) {
      var _props$newPasswordPro2;

      this.setState({
        newPassword: (_props$newPasswordPro2 = props.newPasswordPropsCurr.value) != null ? _props$newPasswordPro2 : ''
      });
    }

    if (confirmPasswordPropsPrev.value !== confirmPasswordPropsCurr.value) {
      var _props$confirmPasswor2;

      this.setState({
        confirmPassword: (_props$confirmPasswor2 = props.confirmPasswordPropsCurr.value) != null ? _props$confirmPasswor2 : ''
      });
    }
  };

  Password.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    // Needed to map until MUI-64/MUI-111 is complete
    // When MUI-64/MUI-111 is complete messageType/messageNode are passed straight down
    var currentMessageInfo = function currentMessageInfo() {
      var modifyPwd = props.modifyPwd,
          _props$currentPasswor3 = props.currentPasswordProps,
          messageType = _props$currentPasswor3.messageType,
          messageNode = _props$currentPasswor3.messageNode;
      var currentPassword = state.currentPassword;

      if (!modifyPwd) {
        return {};
      }

      if (messageType || messageNode) {
        return {
          messageType: messageType != null ? messageType : 'error',
          messageNode: messageNode
        };
      }

      if (!currentPassword.length) {
        return {
          messageType: 'informational',
          messageNode: _StringResource["default"].get('messageCurrentIsBlank')
        };
      } // if (someCheck) {
      //   // additional checks and messages go here
      //   // maybe add a callback for client current password validation
      // }


      return {};
    }; // Needed to map until MUI-64/MUI-111 is complete
    // When MUI-64/MUI-111 is complete messageType/messageNode are passed straight down


    var newMessageInfo = function newMessageInfo() {
      var errorTxtPwd = props.errorTxtPwd,
          modifyPwd = props.modifyPwd,
          _props$newPasswordPro3 = props.newPasswordProps,
          messageType = _props$newPasswordPro3.messageType,
          messageNode = _props$newPasswordPro3.messageNode;
      var currentPassword = state.currentPassword,
          newPassword = state.newPassword;

      if (messageType || messageNode) {
        return {
          messageType: messageType != null ? messageType : 'error',
          messageNode: messageNode
        };
      }

      if (errorTxtPwd) {
        return {
          messageType: 'error',
          messageNode: errorTxtPwd
        };
      }

      if (!newPassword.length) {
        return {
          messageType: 'informational',
          messageNode: _StringResource["default"].get('messageNewIsBlank')
        };
      }

      if (modifyPwd) {
        if (currentPassword.length && currentPassword === newPassword) {
          return {
            messageType: 'error',
            messageNode: _StringResource["default"].get('messageNewAndCurrentMatch')
          };
        }
      } // if (someCheck) {
      // 	// additional checks and messages go here
      // 	// maybe add a callback for client new password validation
      // }


      return {};
    }; // Needed to map until MUI-64/MUI-111 is complete
    // When MUI-64/MUI-111 is complete messageType/messageNode are passed straight down


    var confirmMessageInfo = function confirmMessageInfo() {
      var errorTxtConfirm = props.errorTxtConfirm,
          successTxtConfirm = props.successTxtConfirm,
          _props$confirmPasswor3 = props.confirmPasswordProps,
          messageType = _props$confirmPasswor3.messageType,
          messageNode = _props$confirmPasswor3.messageNode;
      var newPassword = state.newPassword,
          confirmPassword = state.confirmPassword;

      if (messageType || messageNode) {
        return {
          messageType: messageType != null ? messageType : 'error',
          messageNode: messageNode
        };
      }

      if (errorTxtConfirm) {
        return {
          messageType: 'error',
          messageNode: errorTxtConfirm
        };
      }

      if (successTxtConfirm) {
        return {
          messageType: 'success',
          messageNode: successTxtConfirm
        };
      }

      if (!confirmPassword.length) {
        return {
          messageType: 'informational',
          messageNode: _StringResource["default"].get('messageConfirmIsBlank')
        };
      }

      if (newPassword !== confirmPassword) {
        return {
          messageType: 'error',
          messageNode: _StringResource["default"].get('messageNewAndConfirmDoNotMatch')
        };
      } // if (someCheck) {
      // 	// additional checks and messages could go here
      // 	// maybe add a callback for client confirm password validation
      // }


      if (newPassword.length && newPassword === confirmPassword) {
        return {
          messageType: 'success',
          messageNode: _StringResource["default"].get('messageNewAndConfirmMatch')
        };
      }

      return {};
    };

    var _currentMessageInfo = currentMessageInfo(),
        currentMessageType = _currentMessageInfo.messageType,
        currentMessageNode = _currentMessageInfo.messageNode;

    var _newMessageInfo = newMessageInfo(),
        newMessageType = _newMessageInfo.messageType,
        newMessageNode = _newMessageInfo.messageNode;

    var _confirmMessageInfo = confirmMessageInfo(),
        confirmMessageType = _confirmMessageInfo.messageType,
        confirmMessageNode = _confirmMessageInfo.messageNode;

    return {
      currentMessageType: currentMessageType,
      currentMessageNode: currentMessageNode,
      newMessageType: newMessageType,
      newMessageNode: newMessageNode,
      confirmMessageType: confirmMessageType,
      confirmMessageNode: confirmMessageNode,
      isValid: (currentMessageType === undefined || currentMessageType === 'success') && (newMessageType === undefined || newMessageType === 'success') && confirmMessageType === 'success'
    };
  };

  _proto.render = function render() {
    var _this$props$labelCurr, _this$props$labelPwd, _this$props$labelConf;

    var _this$props2 = this.props,
        className = _this$props2.className,
        modifyPwd = _this$props2.modifyPwd,
        onPwdChange = _this$props2.onPwdChange,
        currentPasswordProps = _this$props2.currentPasswordProps,
        newPasswordProps = _this$props2.newPasswordProps,
        confirmPasswordProps = _this$props2.confirmPasswordProps,
        errorTxtConfirm = _this$props2.errorTxtConfirm,
        errorTxtCurrent = _this$props2.errorTxtCurrent,
        errorTxtPwd = _this$props2.errorTxtPwd,
        labelConfirm = _this$props2.labelConfirm,
        labelCurrent = _this$props2.labelCurrent,
        labelPwd = _this$props2.labelPwd,
        successTxtConfirm = _this$props2.successTxtConfirm,
        htmlFor = _this$props2.htmlFor,
        label = _this$props2.label,
        onClear = _this$props2.onClear,
        type = _this$props2.type,
        value = _this$props2.value,
        other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["className", "modifyPwd", "onPwdChange", "currentPasswordProps", "newPasswordProps", "confirmPasswordProps", "errorTxtConfirm", "errorTxtCurrent", "errorTxtPwd", "labelConfirm", "labelCurrent", "labelPwd", "successTxtConfirm", "htmlFor", "label", "onClear", "type", "value"]);
    return /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
      className: pwdClassName + " " + className,
      direction: "column"
    }, modifyPwd && /*#__PURE__*/_react["default"].createElement(PasswordInput, (0, _extends2["default"])({}, other, currentPasswordProps, {
      value: this.state.currentPassword,
      invalid: this.state.currentMessageType === 'error' ? true : undefined,
      invalidText: this.state.currentMessageType === 'error' ? this.state.currentMessageNode : undefined,
      labelText: (_this$props$labelCurr = this.props.labelCurrent) != null ? _this$props$labelCurr : currentPasswordProps.labelText,
      onChange: this._onChangeCurrentPassword
    })), modifyPwd && /*#__PURE__*/_react["default"].createElement(_vspacer["default"], {
      size: 1
    }), /*#__PURE__*/_react["default"].createElement(PasswordInput, (0, _extends2["default"])({}, other, newPasswordProps, {
      value: this.state.newPassword,
      invalid: this.state.newMessageType === 'error' ? true : undefined,
      invalidText: this.state.newMessageType === 'error' ? this.state.newMessageNode : undefined,
      labelText: (_this$props$labelPwd = this.props.labelPwd) != null ? _this$props$labelPwd : newPasswordProps.labelText,
      onChange: this._onChangeNewPassword
    })), /*#__PURE__*/_react["default"].createElement(_vspacer["default"], {
      size: 1
    }), /*#__PURE__*/_react["default"].createElement(PasswordInput, (0, _extends2["default"])({}, other, confirmPasswordProps, {
      value: this.state.confirmPassword,
      invalid: this.state.confirmMessageType === 'error' ? true : undefined,
      invalidText: this.state.confirmMessageType === 'error' ? this.state.confirmMessageNode : undefined,
      labelText: (_this$props$labelConf = this.props.labelConfirm) != null ? _this$props$labelConf : confirmPasswordProps.labelText,
      onChange: this._onChangeConfirmPassword
    })));
  };

  return Password;
}(_react.Component);

exports["default"] = Password;
(0, _defineProperty2["default"])(Password, "propTypes", {
  /** className applied to the flexLayout wrapper */
  className: _propTypes["default"].string,

  /** A flag indicating a if modifying and existing password */
  modifyPwd: _propTypes["default"].bool,

  /** A function called when changes are made. Props = {isValid, currentPassword, newPassword, confirmPassword, pwd(deprecated), currentPwd(deprecated) }. */
  onPwdChange: _propTypes["default"].func,

  /** props passed to the current password input */
  currentPasswordProps: _propTypes["default"].object,

  /** props passed to the new password input */
  newPasswordProps: _propTypes["default"].object,

  /** props passed to the confirm password input */
  confirmPasswordProps: _propTypes["default"].object,

  /** deprecated - use currentPasswordProps.labelText */
  labelCurrent: BaPropTypes.deprecated('deprecated - use currentPasswordProps.labelText'),

  /** deprecated - use newPasswordProps.labelText */
  labelPwd: BaPropTypes.deprecated('deprecated - use newPasswordProps.labelText'),

  /** deprecated - use confirmPasswordProps.labelText */
  labelConfirm: BaPropTypes.deprecated('deprecated - use confirmPasswordProps.labelText'),

  /** deprecated - use currentPasswordProps.messageType and currentPasswordProps.messageText */
  errorTxtCurrent: BaPropTypes.deprecated('deprecated - was never used - use currentPasswordProps.messageType and currentPasswordProps.messageText'),

  /** deprecated - use newPasswordProps.messageType and newPasswordProps.messageText */
  errorTxtPwd: BaPropTypes.deprecated('deprecated - use newPasswordProps.messageType and newPasswordProps.messageText'),

  /** deprecated - use newMessageType.mssageType and newMessageText.messageText */
  errorTxtConfirm: BaPropTypes.deprecated('deprecated - use newMessageType.mssageType and newMessageText.messageText'),

  /** deprecated - use newMessageType.mssageType and newMessageText.messageText */
  successTxtConfirm: BaPropTypes.deprecated('deprecated - use newMessageType.mssageType and newMessageText.messageText')
});
(0, _defineProperty2["default"])(Password, "defaultProps", {
  className: '',
  modifyPwd: false,
  onPwdChange: function onPwdChange() {},
  currentPasswordProps: {
    onChange: function onChange() {},
    hidePasswordLabel: _StringResource["default"].get('hideLabel'),
    labelText: _StringResource["default"].get('currentLabel'),
    showPasswordLabel: _StringResource["default"].get('showLabel')
  },
  newPasswordProps: {
    onChange: function onChange() {},
    hidePasswordLabel: _StringResource["default"].get('hideLabel'),
    labelText: _StringResource["default"].get('newLabel'),
    showPasswordLabel: _StringResource["default"].get('showLabel')
  },
  confirmPasswordProps: {
    onChange: function onChange() {},
    hidePasswordLabel: _StringResource["default"].get('hideLabel'),
    labelText: _StringResource["default"].get('confirmLabel'),
    showPasswordLabel: _StringResource["default"].get('showLabel')
  }
});

var PasswordInput = /*#__PURE__*/function (_Component2) {
  (0, _inheritsLoose2["default"])(PasswordInput, _Component2);

  function PasswordInput() {
    return _Component2.apply(this, arguments) || this;
  }

  var _proto2 = PasswordInput.prototype;

  _proto2.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: pwdClassName + "__input"
    }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.TextInput.PasswordInput, this.props));
  };

  return PasswordInput;
}(_react.Component);

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _PasswordResources = _interopRequireDefault(__webpack_require__(379));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2020
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_PasswordResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

var amdi18n={"__root":{"confirmLabel":"Confirm password","currentLabel":"Current password","hideLabel":"Hide password","messageConfirmIsBlank":"Enter a confirmational password.","messageCurrentIsBlank":"Enter your current password.","messageNewAndConfirmDoNotMatch":"Passwords do not match.","messageNewAndConfirmMatch":"Passwords match.","messageNewAndCurrentMatch":"New password cannot match the current password.","messageNewIsBlank":"Enter a new password.","newLabel":"Password","showLabel":"Show password"},"__cs":{"confirmLabel":"Potvrdit heslo","currentLabel":"Aktuální heslo","hideLabel":"Skrýt heslo","messageConfirmIsBlank":"Zadejte potvrzující heslo.","messageCurrentIsBlank":"Zadejte vaše aktuální heslo.","messageNewAndConfirmDoNotMatch":"Hesla se neshodují.","messageNewAndConfirmMatch":"Hesla se shodují.","messageNewAndCurrentMatch":"Nové heslo nesmí být shodné s heslem aktuálním.","messageNewIsBlank":"Zadejte nové heslo.","newLabel":"Heslo","showLabel":"Zobrazit heslo"},"__da":{"confirmLabel":"Bekræft kodeord","currentLabel":"Aktuelt kodeord","hideLabel":"Skjul kodeord","messageConfirmIsBlank":"Indtast et bekræftende kodeord.","messageCurrentIsBlank":"Indtast dit nuværende kodeord.","messageNewAndConfirmDoNotMatch":"Kodeordene er ikke ens.","messageNewAndConfirmMatch":"Kodeordene er ens.","messageNewAndCurrentMatch":"Nyt kodeord kan ikke være det samme som det aktuelle.","messageNewIsBlank":"Angiv et nyt kodeord.","newLabel":"Kodeord","showLabel":"Vis kodeord"},"__de":{"confirmLabel":"Kennwort bestätigen","currentLabel":"Aktuelles Kennwort","hideLabel":"Kennwort ausblenden","messageConfirmIsBlank":"Bestätigungskennwort eingeben. ","messageCurrentIsBlank":"Aktuelles Kennwort eingeben. ","messageNewAndConfirmDoNotMatch":"Die Kennwörter stimmen nicht überein.","messageNewAndConfirmMatch":"Die Kennwörter stimmen überein.","messageNewAndCurrentMatch":"Das neue Kennwort darf nicht mit dem aktuellen Kennwort übereinstimmen. ","messageNewIsBlank":"Neues Kennwort eingeben. ","newLabel":"Kennwort","showLabel":"Kennwort anzeigen"},"__es":{"confirmLabel":"Confirmar contraseña","currentLabel":"Contraseña actual","hideLabel":"Ocultar contraseña","messageConfirmIsBlank":"Especifique una contraseña de confirmación. ","messageCurrentIsBlank":"Especifique su contraseña actual.","messageNewAndConfirmDoNotMatch":"Las contraseñas no coinciden.","messageNewAndConfirmMatch":"Las contraseñas coinciden.","messageNewAndCurrentMatch":"La nueva contraseña no puede coincidir con la contraseña actual.","messageNewIsBlank":"Especifique una nueva contraseña.","newLabel":"Contraseña","showLabel":"Mostrar contraseña"},"__fi":{"confirmLabel":"Vahvista salasana","currentLabel":"Nykyinen salasana","hideLabel":"Piilota salasana","messageConfirmIsBlank":"Anna salasanan vahvistus.","messageCurrentIsBlank":"Anna nykyinen salasanasi.","messageNewAndConfirmDoNotMatch":"Salasanat eivät täsmää.","messageNewAndConfirmMatch":"Salasanat täsmäävät.","messageNewAndCurrentMatch":"Uusi salasana ei voi olla sama kuin vanha salasana.","messageNewIsBlank":"Anna uusi salasana.","newLabel":"Salasana","showLabel":"Näytä salasana"},"__fr":{"confirmLabel":"Confirmation du mot de passe","currentLabel":"Mot de passe en cours","hideLabel":"Masquer le mot de passe","messageConfirmIsBlank":"Entrez un mot de passe de confirmation.","messageCurrentIsBlank":"Entrez votre mot de passe actuel.","messageNewAndConfirmDoNotMatch":"Les mots de passe ne concordent pas.","messageNewAndConfirmMatch":"Les mots de passe concordent.","messageNewAndCurrentMatch":"Le nouveau mot de passe ne doit pas correspondre au mot de passe en cours.","messageNewIsBlank":"Entrez un nouveau mot de passe.","newLabel":"Mot de passe","showLabel":"Afficher le mot de passe"},"__hr":{"confirmLabel":"Potvrda lozinke","currentLabel":"Trenutna lozinka","hideLabel":"Sakrij lozinku","messageConfirmIsBlank":"Unesi lozinku radi potvrde","messageCurrentIsBlank":"Unesi trenutnu lozinku","messageNewAndConfirmDoNotMatch":"Lozinke se ne podudaraju.","messageNewAndConfirmMatch":"Lozinke se podudaraju.","messageNewAndCurrentMatch":"Nova lozinka ne može se podudarati s trenutnom lozinkom.","messageNewIsBlank":"Unesi novu lozinku.","newLabel":"Lozinka","showLabel":"Pokaži lozinku"},"__hu":{"confirmLabel":"Jelszó megerősítése","currentLabel":"Aktuális jelszó","hideLabel":"Jelszó elrejtése","messageConfirmIsBlank":"Adjon meg egy megerősítő jelszót. ","messageCurrentIsBlank":"Adja meg az aktuális jelszavát. ","messageNewAndConfirmDoNotMatch":"A jelszavak nem egyeznek.","messageNewAndConfirmMatch":"A jelszavak egyeznek.","messageNewAndCurrentMatch":"Az új jelszó nem egyezhet meg az aktuális jelszóval.","messageNewIsBlank":"Adjon meg egy új jelszót. ","newLabel":"Jelszó","showLabel":"Jelszó megjelenítése"},"__it":{"confirmLabel":"Conferma password","currentLabel":"Password attuale","hideLabel":"Nascondi password","messageConfirmIsBlank":"Immettere una password di conferma. ","messageCurrentIsBlank":"Immettere la password corrente. ","messageNewAndConfirmDoNotMatch":"Le password non corrispondono.","messageNewAndConfirmMatch":"Le password corrispondono.","messageNewAndCurrentMatch":"La nuova password non può corrispondere alla password attuale.","messageNewIsBlank":"Immettere una nuova password. ","newLabel":"Password","showLabel":"Mostra password"},"__ja":{"confirmLabel":"パスワードの確認","currentLabel":"現在のパスワード","hideLabel":"パスワードを非表示にする","messageConfirmIsBlank":"確認のためにパスワードをもう一度入力してください。","messageCurrentIsBlank":"現在のパスワードを入力してください。","messageNewAndConfirmDoNotMatch":"パスワードが一致しません。","messageNewAndConfirmMatch":"パスワードが一致しました。","messageNewAndCurrentMatch":"新しいパスワードが現在のパスワードと一致しません。","messageNewIsBlank":"新規パスワードを入力してください。","newLabel":"パスワード","showLabel":"パスワードを表示"},"__kk":{"confirmLabel":"Құпия сөзді растау","currentLabel":"Ағымдағы Құпия сөз","hideLabel":"Құпия сөзді жасыру","messageConfirmIsBlank":"Растайтын құпия сөзді енгізіңіз.","messageCurrentIsBlank":"Ағымдағы құпия сөзді енгізіңіз.","messageNewAndConfirmDoNotMatch":"Құпия сөздер сәйкес емес.","messageNewAndConfirmMatch":"Сәйкес құпія сөздер.","messageNewAndCurrentMatch":"Жаңа құпия сөз қазіргі ағымдағы құпия сөзге сәйкес келмейді.","messageNewIsBlank":"Жаңа құпия сөзді енгізіңіз.","newLabel":"Құпия сөз","showLabel":"Құпия сөзді көрсету"},"__ko":{"confirmLabel":"비밀번호 확인","currentLabel":"현재 비밀번호","hideLabel":"비밀번호 숨기기","messageConfirmIsBlank":"확인 비밀번호를 입력하십시오.","messageCurrentIsBlank":"현재 비밀번호를 입력하십시오.","messageNewAndConfirmDoNotMatch":"비밀번호가 일치하지 않습니다.","messageNewAndConfirmMatch":"비밀번호가 일치합니다.","messageNewAndCurrentMatch":"새 비밀번호는 현재 비밀번호와 일치할 수 없습니다.","messageNewIsBlank":"새 비밀번호를 입력하십시오.","newLabel":"비밀번호","showLabel":"비밀번호 표시"},"__nb":{"confirmLabel":"Bekreft passord","currentLabel":"Gjeldende passord","hideLabel":"Skjul passord","messageConfirmIsBlank":"Oppgi et bekreftelsespassord.","messageCurrentIsBlank":"Oppgi ditt gjeldende passord.","messageNewAndConfirmDoNotMatch":"Passordene samsvarer ikke.","messageNewAndConfirmMatch":"Passordene samsvarer.","messageNewAndCurrentMatch":"Nytt passord kan ikke være likt gjeldende passord.","messageNewIsBlank":"Oppgi et nytt passord.","newLabel":"Passord","showLabel":"Vis passord"},"__nl":{"confirmLabel":"Wachtwoord bevestigen","currentLabel":"Huidig wachtwoord","hideLabel":"Wachtwoord verbergen","messageConfirmIsBlank":"Geef een wachtwoord ter bevestiging op.","messageCurrentIsBlank":"Geef het huidige wachtwoord op.","messageNewAndConfirmDoNotMatch":"De wachtwoorden zijn niet gelijk.\n","messageNewAndConfirmMatch":"De wachtwoorden zijn gelijk.\n","messageNewAndCurrentMatch":"Nieuw wachtwoord mag niet gelijk zijn aan huidig wachtwoord.","messageNewIsBlank":"Geef een nieuw wachtwoord op.","newLabel":"Wachtwoord","showLabel":"Wachtwoord afbeelden\n"},"__no":{"confirmLabel":"Bekreft passord","currentLabel":"Gjeldende passord","hideLabel":"Skjul passord","messageConfirmIsBlank":"Oppgi et bekreftelsespassord.","messageCurrentIsBlank":"Oppgi ditt gjeldende passord.","messageNewAndConfirmDoNotMatch":"Passordene samsvarer ikke.","messageNewAndConfirmMatch":"Passordene samsvarer.","messageNewAndCurrentMatch":"Nytt passord kan ikke være likt gjeldende passord.","messageNewIsBlank":"Oppgi et nytt passord.","newLabel":"Passord","showLabel":"Vis passord"},"__pl":{"confirmLabel":"Potwierdź hasło","currentLabel":"Obecne hasło","hideLabel":"Ukryj hasło","messageConfirmIsBlank":"Wprowadź hasło potwierdzające.","messageCurrentIsBlank":"Wprowadź aktualne hasło.","messageNewAndConfirmDoNotMatch":"Hasła nie zgadzają się.","messageNewAndConfirmMatch":"Hasła zgadzają się.","messageNewAndCurrentMatch":"Nowe hasło nie może być identyczne z obecnym.","messageNewIsBlank":"Wprowadź nowe hasło.","newLabel":"Hasło","showLabel":"Pokaż hasło"},"__pt":{"confirmLabel":"Senha de Confirmação","currentLabel":"Senha Atual:","hideLabel":"Oculte a senha","messageConfirmIsBlank":"Insira uma senha de confirmação.","messageCurrentIsBlank":"Insira sua senha atual.","messageNewAndConfirmDoNotMatch":"As senhas não correspondem.","messageNewAndConfirmMatch":"As senhas correspondem.","messageNewAndCurrentMatch":"A nova senha não pode corresponder à senha atual.","messageNewIsBlank":"Digite uma nova senha.","newLabel":"Senha","showLabel":"Exiba a senha"},"__pt-br":{"confirmLabel":"Senha de Confirmação","currentLabel":"Senha Atual:","hideLabel":"Oculte a senha","messageConfirmIsBlank":"Insira uma senha de confirmação.","messageCurrentIsBlank":"Insira sua senha atual.","messageNewAndConfirmDoNotMatch":"As senhas não correspondem.","messageNewAndConfirmMatch":"As senhas correspondem.","messageNewAndCurrentMatch":"A nova senha não pode corresponder à senha atual.","messageNewIsBlank":"Digite uma nova senha.","newLabel":"Senha","showLabel":"Exiba a senha"},"__ro":{"confirmLabel":"Confirmaţi parola","currentLabel":"Parola curentă","hideLabel":"Ascundere parolă ","messageConfirmIsBlank":"Introduceţi parola de confirmare.","messageCurrentIsBlank":"Introduceţi parola curentă.","messageNewAndConfirmDoNotMatch":"Parolele nu se potrivesc.","messageNewAndConfirmMatch":"Parolele se potrivesc.","messageNewAndCurrentMatch":"Parola nouă nu poate fi identică cu parola curentă.","messageNewIsBlank":"Introduceţi o parolă nouă.","newLabel":"Parolă","showLabel":"Afişare parolă"},"__ru":{"confirmLabel":"Подтверждение пароля","currentLabel":"Текущий пароль","hideLabel":"Скрыть пароль","messageConfirmIsBlank":"Введите подтверждение пароля.","messageCurrentIsBlank":"Введите свой текущий пароль.","messageNewAndConfirmDoNotMatch":"Пароли не совпадают.","messageNewAndConfirmMatch":"Пароли совпадают.","messageNewAndCurrentMatch":"Новый пароль не должен совпадать с текущим паролем.","messageNewIsBlank":"Введите новый пароль","newLabel":"Пароль","showLabel":"Показать пароль"},"__sl":{"confirmLabel":"Potrditev gesla","currentLabel":"Trenutno geslo","hideLabel":"Skrij geslo","messageConfirmIsBlank":"Vnesite potrditveno geslo. ","messageCurrentIsBlank":"Vnesite trenutno geslo. ","messageNewAndConfirmDoNotMatch":"Gesli se ne ujemata.","messageNewAndConfirmMatch":"Gesli se ujemata.","messageNewAndCurrentMatch":"Novo geslo se ne sme ujemati s trenutnim geslom.","messageNewIsBlank":"Vnesite novo geslo. ","newLabel":"Geslo","showLabel":"Pokaži geslo"},"__sv":{"confirmLabel":"Bekräfta lösenord","currentLabel":"Aktuellt lösenord","hideLabel":"Dölj lösenord","messageConfirmIsBlank":"Ange ett bekräftelselösenord.","messageCurrentIsBlank":"Ange nuvarande lösenord.","messageNewAndConfirmDoNotMatch":"Lösenorden stämmer inte överens.","messageNewAndConfirmMatch":"Lösenorden stämmer.","messageNewAndCurrentMatch":"Det nya lösenordet får inte vara samma som det aktuella lösenordet.","messageNewIsBlank":"Ange en nytt lösenord.","newLabel":"Lösenord","showLabel":"Visa lösenord"},"__th":{"confirmLabel":"ยืนยันรหัสผ่าน","currentLabel":"รหัสผ่านปัจจุบัน","hideLabel":"ซ่อนรหัสผ่าน","messageConfirmIsBlank":"ป้อนรหัสผ่านที่ต้องการยืนยัน","messageCurrentIsBlank":"ป้อนรหัสผ่านปัจจุบันของคุณ","messageNewAndConfirmDoNotMatch":"รหัสผ่านไม่ตรง","messageNewAndConfirmMatch":"รหัสผ่านตรงกัน","messageNewAndCurrentMatch":"รหัสผ่านใหม่ไม่ตรงกับรหัสผ่านปัจจุบัน","messageNewIsBlank":"ป้อนรหัสผ่านใหม่","newLabel":"รหัสผ่าน","showLabel":"แสดงรหัสผ่าน"},"__tr":{"confirmLabel":"Parolayı onayla","currentLabel":"Geçerli parola","hideLabel":"Parolayı gizle","messageConfirmIsBlank":"Doğrulayıcı bir parola girin.","messageCurrentIsBlank":"Geçerli parolanızı girin.","messageNewAndConfirmDoNotMatch":"Parolalar eşleşmiyor.","messageNewAndConfirmMatch":"Parolalar eşleşiyor.","messageNewAndCurrentMatch":"Yeni parola geçerli parolayla eşleşemez.","messageNewIsBlank":"Yeni bir parola girin.","newLabel":"Parola","showLabel":"Parolayı göster"},"__zh":{"confirmLabel":"确认密码","currentLabel":"当前密码","hideLabel":"隐藏密码","messageConfirmIsBlank":"请输入确认密码。","messageCurrentIsBlank":"请输入您的当前密码。","messageNewAndConfirmDoNotMatch":"密码不匹配。","messageNewAndConfirmMatch":"密码匹配。","messageNewAndCurrentMatch":"新密码与当前密码不匹配。","messageNewIsBlank":"请输入新密码。","newLabel":"密码","showLabel":"显示密码"},"__zh-cn":{"confirmLabel":"确认密码","currentLabel":"当前密码","hideLabel":"隐藏密码","messageConfirmIsBlank":"请输入确认密码。","messageCurrentIsBlank":"请输入您的当前密码。","messageNewAndConfirmDoNotMatch":"密码不匹配。","messageNewAndConfirmMatch":"密码匹配。","messageNewAndCurrentMatch":"新密码与当前密码不匹配。","messageNewIsBlank":"请输入新密码。","newLabel":"密码","showLabel":"显示密码"},"__zh-hk":{"confirmLabel":"確認密碼","currentLabel":"現行密碼","hideLabel":"隱藏密碼","messageConfirmIsBlank":"輸入確認密碼。","messageCurrentIsBlank":"輸入現行密碼。","messageNewAndConfirmDoNotMatch":"密碼不符。","messageNewAndConfirmMatch":"密碼相符。","messageNewAndCurrentMatch":"新密碼無法與現行密碼相符。","messageNewIsBlank":"輸入新密碼。","newLabel":"密碼","showLabel":"顯示密碼"},"__zh-mo":{"confirmLabel":"確認密碼","currentLabel":"現行密碼","hideLabel":"隱藏密碼","messageConfirmIsBlank":"輸入確認密碼。","messageCurrentIsBlank":"輸入現行密碼。","messageNewAndConfirmDoNotMatch":"密碼不符。","messageNewAndConfirmMatch":"密碼相符。","messageNewAndCurrentMatch":"新密碼無法與現行密碼相符。","messageNewIsBlank":"輸入新密碼。","newLabel":"密碼","showLabel":"顯示密碼"},"__zh-sg":{"confirmLabel":"确认密码","currentLabel":"当前密码","hideLabel":"隐藏密码","messageConfirmIsBlank":"请输入确认密码。","messageCurrentIsBlank":"请输入您的当前密码。","messageNewAndConfirmDoNotMatch":"密码不匹配。","messageNewAndConfirmMatch":"密码匹配。","messageNewAndCurrentMatch":"新密码与当前密码不匹配。","messageNewIsBlank":"请输入新密码。","newLabel":"密码","showLabel":"显示密码"},"__zh-tw":{"confirmLabel":"確認密碼","currentLabel":"現行密碼","hideLabel":"隱藏密碼","messageConfirmIsBlank":"輸入確認密碼。","messageCurrentIsBlank":"輸入現行密碼。","messageNewAndConfirmDoNotMatch":"密碼不符。","messageNewAndConfirmMatch":"密碼相符。","messageNewAndCurrentMatch":"新密碼無法與現行密碼相符。","messageNewIsBlank":"輸入新密碼。","newLabel":"密碼","showLabel":"顯示密碼"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(381);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "\n", ""]);

// exports
exports.locals = {
	"pwdClassName": "\"ba-common-password\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__44__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[375,0]]]);
});